// extracted by mini-css-extract-plugin
module.exports = {"arrow":"_4f720283bf--arrow--BB4EA","arrow-left":"_4f720283bf--arrow-left--a2tJ0"};